module.exports = __webpack_public_path__ + "stylesheets/logo_18b65b8b7c34e0c663f6c8e09400195d.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/logo.less
// module id = wCd9
// module chunks = 151